import { __assign, __makeTemplateObject, __rest } from "tslib";
import React, { forwardRef, useMemo } from 'react';
import MuiTabPanel from '@material-ui/lab/TabPanel';
import { combineClasses, styled, useThemeProps, } from '../../../foundation';
import { useTabContext } from '../TabContext';
import { TabPanelStyle } from './styles';
import { RcTabPanelClasses } from './utils';
var _RcTabPanel = forwardRef(function (inProps, ref) {
    var props = useThemeProps({ props: inProps, name: 'RcTabPanel' });
    var classesProp = props.classes, children = props.children, rest = __rest(props, ["classes", "children"]);
    var classes = useMemo(function () { return combineClasses(RcTabPanelClasses, classesProp); }, [classesProp]);
    // * that just check is that have context, others let mui handle inner
    var context = useTabContext();
    if (context === null) {
        throw new TypeError('[RcTabList] No RcTabContext provided');
    }
    return (React.createElement(MuiTabPanel, __assign({}, rest, { ref: ref, classes: classes }), children));
});
var RcTabPanel = styled(_RcTabPanel)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), TabPanelStyle);
RcTabPanel.defaultProps = {};
RcTabPanel.displayName = 'RcTabPanel';
export { RcTabPanel };
var templateObject_1;
